// extracted by mini-css-extract-plugin
export default {"row_hover":"caps_renderer_row_hover__H5VYQ"};